import classes from './ClueButton.module.scss';
import useClues from '../CluesProvider/useClues';
import { Educapoint } from '@educaplay/core/Icons/Educapoint';
import { COLORS, NAME_SOUND_ACTIVE, useGameSounds } from '@educaplay/core';
import { ClueIcon, ClueImageIcon, ClueInformationIcon, ClueLetterIcon } from '../../icons';
import { VARIANT_ICON_BUTTON } from '../../utils/constants';
import { useEffect, useState } from 'react';
import clsx from 'clsx';
import { useSelector } from 'react-redux';
import { AnimatePresence, motion } from 'framer-motion';

const IconSelected = {
    [VARIANT_ICON_BUTTON.INFORMATION]: <ClueInformationIcon />,
    [VARIANT_ICON_BUTTON.IMAGE]: <ClueImageIcon />,
    [VARIANT_ICON_BUTTON.LETTERS]: <ClueLetterIcon />
}
const DELAY_ANIMATION_BUTTON = 800;
const DELAY_ANIMATION_EXIT_BUTTON = DELAY_ANIMATION_BUTTON + 150;

function ClueButton(props) {
    const { clueButtonRef } = props;
    const { numRequestedClues, requesteNextClue, clueCost, disabledRequestClue, currentIconButton, numClues } = useClues();
    const currentQuestion = useSelector(state => state.game.questions[state.game.currentIndex]);
    const progress = 100 - ((numRequestedClues / numClues) * 100);
    const [isPressed, setIsPressed] = useState(false);
    const isAnimating = useSelector(state => state.game.isAnimating);
    const hasBank = !!currentQuestion.bank;
    const [infoButton, setInfoButton] = useState({ icon: currentIconButton, cost: clueCost });
    const [disabledButton, setDisabledButton] = useState(disabledRequestClue);
    const clueCostFormatted = infoButton?.cost.toFixed(3);
    const gameSounds = useGameSounds();

    useEffect(() => {
        setTimeout(() => {
            setInfoButton({ icon: currentIconButton, cost: clueCost });
        }, DELAY_ANIMATION_BUTTON);
    }, [currentIconButton, clueCost])

    useEffect(() => {
        setTimeout(() => {
            setDisabledButton(disabledRequestClue);
        }, DELAY_ANIMATION_EXIT_BUTTON);
    },
        [disabledRequestClue])

    useEffect(() => {
        setTimeout(() => {
            setDisabledButton(disabledRequestClue);
        }, 200);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [currentQuestion.id])


    const onClickHandler = () => {
        if (isAnimating || isPressed) return;
        setIsPressed(true);
        requesteNextClue();


        setTimeout(() => {
            setIsPressed(false);
        }, DELAY_ANIMATION_BUTTON);
    }

    return (
        <AnimatePresence>
            {!disabledButton && (<motion.div ref={clueButtonRef}
                className={clsx(classes.cluebuttoncontainer, !hasBank && classes.adjusttop)}
                initial={{ opacity: 0, x: "100%" }}
                animate={{ opacity: 1, x: 0 }}
                exit={{ x: "150%" }}
                transition={{ duration: .3, type: "spring", delay: .2 }}
            >
                <button onClick={onClickHandler} className={clsx(classes.cluebutton, isPressed && classes.active)} onMouseEnter={() => { gameSounds.play(NAME_SOUND_ACTIVE) }}>
                    <span className={classes.centralicon}>
                        <ClueIcon />
                    </span>
                    <div className={classes.pointscontainer}>
                        <span className={classes.educaicon}><Educapoint color={COLORS.white} /></span>
                        <span className={classes.pointsvalue}>-{clueCostFormatted}</span>
                    </div>
                    <span className={classes.modeicon}>
                        {IconSelected[infoButton?.icon]}
                    </span>
                </button>
                {!isPressed && (
                    <div
                        role="progressbar"
                        aria-valuenow={progress}
                        className={classes.progressBarContainer}
                    >
                        <div className={classes.progress} style={{ width: `${progress}%` }} />
                    </div>)}
            </motion.div>)}
        </AnimatePresence>
    )
}

export default ClueButton; 